import classNames from 'classnames/bind';
import React from 'react';
import {
  Button, Col, Form, ListGroup, Row,
} from 'react-bootstrap';
import { useAchievementsContext } from '../../../../../../contexts/AchievementsContext/AchievementsContext';
import { AutoAchievement } from '../../../../../../dorian-shared/types/branch/AnswerStep';
import styles from '../Steps.scss';

const cs = classNames.bind(styles);

export interface AnswerAutoAchievementItemProps {
  index: number;
  answerIndex: number;
  stepIndex: number;
  activeSteps: string;
  activeStepsFunc: (step: string) => void;
  value: AutoAchievement;
  onDelete: () => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export function AnswerAutoAchievementItem(props: AnswerAutoAchievementItemProps) {
  const {
    index,
    answerIndex,
    stepIndex,
    activeSteps,
    activeStepsFunc,
    value,
    onDelete,
    onChange,
  } = props;

  const { achievements } = useAchievementsContext();

  const activeStepString = `steps-${stepIndex}-answers-${answerIndex}-autoAchievements-${index}`;
  const isActive = activeSteps === activeStepString;

  return (
    <ListGroup.Item as="li" className={cs('p-0', 'branchesList-li')}>
      <Row className={cs('py-1', 'justify-content-between', { 'active-item': isActive })}>
        <Form.Group
          as={Col}
          controlId={`answer_${answerIndex}_autoAchievements${index}_key`}
          className={cs('mb-0')}
        >
          <Row>
            <Form.Label className={cs('text-right', 'px-1')} column md="auto">
              Achievement:
            </Form.Label>
            <Col sm={4} className={cs('mb-0', 'px-1')}>
              <Form.Control
                size="sm"
                as="select"
                value={String(value ?? 0)}
                name={`steps[${stepIndex}][answers][${answerIndex}][autoAchievements][${index}]`}
                onFocus={() => activeStepsFunc(activeStepString)}
                onMouseDown={(e: React.MouseEvent<HTMLSelectElement>) => e.stopPropagation()}
                onChange={onChange}
              >
                <option value="0" disabled>N/A</option>
                {
                  achievements.map((achievement) => (
                    <option key={achievement.id} value={String(achievement.id)}>
                      {achievement.name}
                    </option>
                  ))
                }
              </Form.Control>
            </Col>
          </Row>
        </Form.Group>
        <Col sm={2} xl={1} className="text-right">
          <Button
            className="ml-1 btnDeleteImgSm"
            size="sm"
            variant="secondary"
            onClick={onDelete}
            onFocus={() => activeStepsFunc(activeStepString)}
            onMouseDown={(e) => e.stopPropagation()}
          />
        </Col>
      </Row>
    </ListGroup.Item>
  );
}
